angular.module('app.profile').component('profileAgentDisplay', {
  templateUrl: 'profile/components/agents/agent-display.html',

  bindings: {
    representation: '<',
  },
});
